
import React, { Fragment } from 'react';

import "./index.scss";
import { Toast } from './Toast';

const dayTable = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
];

const monthTable = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const timescrollerTimes = [
    { key: '0000', value: 'Midnight' },
    { key: '0430', value: 'Early morning' },
    { key: '0900', value: 'Morning' },
    { key: '1200', value: 'Noon' },
    { key: '1530', value: 'Afternoon' },
    { key: '1700', value: 'Evening' },
    { key: '1930', value: 'Late evening' },
    { key: '2100', value: 'Night' },
    { key: '2230', value: 'Late night' },
];

const timescrollerTimeLookup = new Map(
    timescrollerTimes.map((item, index) => [item.key, index]));

const dayOptionsTo31 = Array.from({length: 31}).map((_, i) => {
    const dayStr = '' + (i + 1);
    return <option key={dayStr}
        value={dayStr}
        children={dayStr}/>;
})

export class Calendar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    _wrapClampAndSetSelectedDate(newDate) {
        //
        // Wrap

        if (newDate.getTime() > this.state.today.getTime()) {
            newDate.setFullYear(newDate.getFullYear() - 1);
        }
        if (newDate.getTime() < this.state.minDate.getTime()) {
            newDate.setFullYear(newDate.getFullYear() + 1);
        }

        //
        // Clamp

        if (newDate.getTime() < this.state.minDate.getTime())
            newDate.setTime(this.state.minDate.getTime());
        if (newDate.getTime() > this.state.today.getTime())
            newDate.setTime(this.state.today.getTime());

        //
        // Set

        this.props.onChangeSelectedDate(newDate);
    }

    render() {
        const weekRows = [];

        const todayTime = this.props.today.getTime();

        const today = this.props.today;

        const base = this.props.selectedDate || this.props.today;

        // Copy selected date
        const end = new Date(base.getTime());
        // Set to 1st
        end.setDate(1);
        // Advance to next month
        end.setMonth(end.getMonth() + 1);
        // Bump back to last day of selected month
        end.setDate(0);
        // Align to start of week
        end.setDate((end.getDate() - end.getDay()) + 14);

        // Start at the selected date
        const dateIt = new Date(base.getTime());

        // Jump to the 1st of that month
        dateIt.setDate(1);

        // Find what day of the week it is
        const dayOfWeekOf1st = dateIt.getDay();

        // Rewind to first row's sunday
        dateIt.setDate(1 - dayOfWeekOf1st - 7);

        while (dateIt.getTime() < end.getTime()) {
            const days = Array.from({length: 7}).map((_, i) => {
                const baseTime = base.getTime();
                const weekStart = dateIt.getTime();
                const date = new Date(weekStart);
                date.setDate(date.getDate() + i);
                const isThisMonth = date.getMonth() === base.getMonth();
                const isSelectedDay = date.getTime() === baseTime;
                const dow = date.getDay();
                const isWeekend = dow < 1 || dow > 5;
                const isFuture = date.getTime() > todayTime;
                const isAncient = date.getTime() <
                    this.props.minDate.getTime();
                const isOob = isFuture || isAncient;
                const isFailed = this.props.failed.has(date.getTime());

                return <td key={date.getTime()}
                    className={'calendar-day' +
                        (isThisMonth ? ' this-month' : ' other-month') +
                        (isWeekend ? ' calendar-weekend' : ' calendar-weekday') +
                        (isSelectedDay ? ' selected' : '') +
                        (isOob ? ' calendar-oob' : '') +
                        (isFailed ? ' calendar-failed' : '')}
                    onClick={(event) => {
                        event.preventDefault();
                        if (!isOob)
                            this.props.onChangeSelectedDate(date);
                    }}
                >
                    {date.getDate()}
                </td>;
            });
            weekRows.push(<tr className="calendar-week-row"
                key={dateIt.getTime()}
                children={days}/>);
            dateIt.setDate(dateIt.getDate() + 7);
        }

        const todaySelected = base.getTime() ===
            this.props.today.getTime();
        const minDateSelected = base.getTime() ===
            this.props.minDate.getTime();

        const dayCountDate = new Date(base.getTime());
        dayCountDate.setDate(1);
        dayCountDate.setMonth(dayCountDate.getMonth() + 1);
        dayCountDate.setDate(0);
        const daysInMonth = dayCountDate.getDate();
        const dayOptions = dayOptionsTo31.slice(0, daysInMonth);

        const monthGroups = [[], []];

        // Put the months into optgroups indicating which year they are
        monthTable.forEach((monthName, monthIndex) => {
            const isPrevYear = (monthIndex > this.props.today.getMonth());
            monthGroups[+isPrevYear].push(<option
                key={monthName}
                value={'' + monthIndex}
                children={monthName}/>);
        });

        const thisYear = today.getFullYear();
        const lastYear = thisYear - 1;

        const thisYearText = '' + thisYear;
        const lastYearText = '' + lastYear;

        const monthOptGroups = [
            <optgroup label={thisYearText}
                key={thisYearText}
                children={monthGroups[0]} />,
            <optgroup label={lastYearText}
                key={lastYearText}
                children={monthGroups[1]} />
        ];

        if (monthGroups[0].length === 0)
            monthOptGroups.shift();
        if (monthGroups[monthGroups.length-1].length === 0)
            monthOptGroups.pop();

        // Year
        const yearOptions = [];

        if (base.getMonth() >= today.getMonth()) {
            yearOptions.push(<option
                key={'lastyear'}
                value={lastYearText}
                children={lastYearText}
                />
            );
        }

        if (base.getMonth() <= today.getMonth()) {
            yearOptions.push(<option
                key={'thisyear'}
                value={thisYearText}
                children={thisYearText}
                />
            );
        }

        const monthsAgo = (today.getFullYear() * 12 + today.getMonth()) -
            (base.getFullYear() * 12 + base.getMonth());
        const daysAgo = Math.floor((today.getTime() -
            base.getTime()) / 86400e3);

        let dateDescription = (daysAgo > 30 && monthsAgo > 0)
            ? `${monthsAgo} month${monthsAgo>1?'s':''} ago`
            : daysAgo
            ? `${daysAgo} day${daysAgo>1?'s':''} ago`
            : `Today`;

        if (dateDescription === '1 day ago')
            dateDescription = 'Yesterday';

        const dayNameCells = dayTable.map((dayName) => {
            return <td className="calendar-day-name" key={dayName}
                children={dayName}/>;
        });

        const monthSelect = <select children={monthOptGroups}
            value={'' + base.getMonth()}
            onChange={(event) => {
                const newDate = new Date(base.getTime());
                newDate.setMonth(+event.target.value);
                this._wrapClampAndSetSelectedDate(newDate);
            }}
            />;

        const daySelect = <select children={dayOptions}
            value={'' + base.getDate()}
            onChange={(event) => {
                const newDate = new Date(base.getTime());
                newDate.setDate(+event.target.value);
                // If they go after today,
                // they must mean almost a year ago
                if (newDate.getTime() > this.props.today.getTime())
                    newDate.setFullYear(this.props.minDate.getFullYear());
                // If they go before the beginning,
                // they must mean near the end
                if (newDate.getTime() < this.props.minDate.getTime())
                    newDate.setFullYear(this.props.today.getFullYear());
                // Clamp to inside range
                if (newDate.getTime() < this.props.minDate.getTime())
                    newDate.setTime(this.props.minDate.getTime());
                if (newDate.getTime() > this.props.today.getTime())
                    newDate.setTime(this.props.today.getTime());
                this._setSelectedDate(newDate);
            }}
        />;

        const yearSelect = <select children={yearOptions}
            value={'' + base.getFullYear()}
            onChange={(event) => {
                const newDate = new Date(base.getTime());
                newDate.setFullYear(+event.target.value);
                if (newDate.getTime() <
                    this.props.minDate.getTime())
                    newDate.setTime(this.props.minDate.getTime());
                else if (newDate.getTime() >
                    this.props.today.getTime())
                    newDate.setTime(this.props.today.getTime());
                this._setSelectedDate(newDate);
            }}
        />;

        const datePicker = <div
            className="datepicker-container inline-container"
        >
            <table>
                <tbody>
                    <tr className="calendar-date-row">
                        <td>
                            <button className="btn-sm calendar-day-button"
                                type="button"
                                disabled={minDateSelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(-1, 0, 0, 0);
                                }}
                            >
                                ◀◀ M
                            </button>
                        </td>
                        <td>
                            <button className="btn-sm calendar-day-button"
                                type="button"
                                disabled={minDateSelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(0, -1, 0, 0);
                                }}
                            >
                                ◀ D
                            </button>
                        </td>
                        <td colSpan={3}>
                            &nbsp;
                        </td>
                        <td>
                            <button className="btn-sm calendar-day-button"
                                type="button"
                                disabled={todaySelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(0, 1, 0, 0);
                                }}
                            >
                                ▶ D
                            </button>
                        </td>
                        <td>
                            <button className="btn-sm calendar-day-button"
                                type="button"
                                disabled={todaySelected}
                                onClick={(event) => {
                                    event.preventDefault();
                                    this._adjustSelectedDate(1, 0, 0, 0);
                                }}
                            >
                                ▶▶ M
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        <td colSpan={12} className="date-description">
                            {dateDescription}
                        </td>
                    </tr>
                    <tr>
                        <td className="calendar-date" colSpan={7}>
                            {monthSelect}
                            {daySelect}
                            {yearSelect}
                        </td>
                    </tr>
                    <tr children={dayNameCells}/>
                    {weekRows}
                </tbody>
            </table>
        </div>;

        const datepickerContainer =
        <div className="datepicker-container inline-container">
            <table className="datepicker-table">
                <tbody>
                    <tr>
                        <td colSpan={7} children={datePicker}/>
                    </tr>
                </tbody>
            </table>
        </div>;

        return datepickerContainer;
    }
}

export default class Camera extends React.Component {
    constructor(props) {
        super(props);

        console.log('Camera component deviceId', props.deviceId, 
            'before toLowerCase');

        // Local midnight
        const localMidnight = new Date();
        localMidnight.setHours(0, 0, 0, 0);

        const minDate = new Date(localMidnight.getTime());
        minDate.setDate(minDate.getDate() - 364);

        this.state = {
            /** @type {boolean | null} */
            cameraExists: null,

            //
            // Date
            /** @type {string} */
            macaddr: this._macaddrFromDeviceId(props.deviceId),

            /** 
             * Null selected date means today
             * @type {Date | null}
             */
            selectedDate: null,

            /** @type {Date} */
            minDate: minDate,

            /** @type {Date} */
            today: localMidnight,

            //
            // Time

            /** @type {number | null} */
            timeIndex: null,

            /** 
             * When the user navigates to a time, it
             * becomes the "desired time", which is
             * sought when you change the date,
             * to prime timeIndex
             * @type {string}
             */
            desiredTimeOfDay: '000000',

            /**
             * key on yyyymmdd, value are
             * objects keyed on hhmmss, values are urls
             * @type {Map<string, string> | null}
             */
            dateLookup: null,

            /** 
             * Populated with images from the selected date
             * @type {Array<{key: string, value: string}> | null}
             */
            timeList: null,

            /**
             * This is captured from the first response
             * This is to avoid having to redundantly give
             * the common prefix on all the signed urls
             * @type {string}
             */
            urlPrefix: '',

            /**
             * Used by the Toast component to hold toast messages
             * @type {Map<number, unknown>}
             */
            messages: new Map(),

            /**
             * Holds the local midnight timestamp for each day 
             * whose image list did not load
             * @type {Set<number>}
             */
            failed: new Set(),

            brightness: 1,
            contrast: 1,
            scale: 2,
            panX: 0,
            panY: 0
        };

        this._messageExpirer = Toast.makeRemover(this, 'messages');

        this._midnightTimer = null;
    }
    
    _mounted = false;
    
    componentDidMount() {
        this._mounted = true;
        console.log('mounting camera component');
        this._scheduleNextMidnight();

        const loadedDate = new Date(this.state.today.getTime());
        this._changeDate(loadedDate)
        .then((exists) => {
            this.setState({
                initialLoading: false,
                cameraExists: exists
            });
            this._updateAutoRefresh();
        }).catch((err) => {
            this.setState({
                cameraExists: false
            })
        });
    }

    componentWillUnmount() {
        if (this._autorefreshTimeout) {
            clearTimeout(this._autorefreshTimeout);
            this._autorefreshTimeout = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        console.log('component did update', this.props, this.state);

        if (prevState.selectedDate !== this.state.selectedDate) {
            this._changeDate(this.state.selectedDate || this.state.today);

            // If the truthiness of selectedDate state changed
            if (!prevState.selectedDate !== !this.state.selectedDate) {
                // Update the timeList refresh
                this._updateAutoRefresh();
            }
        }
    }

    _autorefreshTimeout = null;

    _updateAutoRefresh() {
        if (this.state.selectedDate) {
            // turn off autorefresh
            if (this._autorefreshTimeout) {
                clearTimeout(this._autorefreshTimeout);
                this._autorefreshTimeout = null;
            }
        } else {
            // turn on autorefresh
            // Starting one minute from now, round up to the next
            // 15 minute boundary, plus 15 seconds, 
            // randomized by 4 seconds to attenuate the stampede
            // Starting from now
            this._scheduleAutoRefresh();
        }
    }

    _scheduleAutoRefresh() {
        const autoRefreshTime = new Date();
        // Add 60 seconds
        autoRefreshTime.setUTCSeconds(
            autoRefreshTime.getUTCSeconds() + 60);
        // then force the seconds offset to be large enough 
        // that the device has almost certainly uploaded by then
        autoRefreshTime.setUTCSeconds(20 + Math.random() * 4, 0);
        // Round the minutes up to an
        // actual 15 minute wallclock boundary
        // (keeping the randomized seconds offset and delay)
        let minutes = autoRefreshTime.getUTCMinutes();
        minutes += 14;
        minutes -= minutes % 15;
        autoRefreshTime.setUTCMinutes(minutes);

        const waitMs = autoRefreshTime.getTime() -
            Date.now();

        if (this._autorefreshTimeout) {
            clearTimeout(this._autorefreshTimeout);
            this._autorefreshTimeout = null;
        }

        const doAutoRefresh = () => {
            this._autoRefresh()
            .then(() => {
                if (this._mounted && !this.state.selectedDate)
                    this._scheduleAutoRefresh();
            });
        };

        if (waitMs > 0) {
            this._autorefreshTimeout =
                setTimeout(doAutoRefresh, waitMs);
        } else {
            doAutoRefresh();
        }
    }

    _autoRefresh() {
        if (!this.state.selectedDate) {
            console.log('autorefreshing');
            return this.loadDate(this.state.today, true);
        }
        return Promise.resolve();
    }

    _macaddrFromDeviceId(deviceId) {
        return deviceId.toLowerCase().split(':', 1)[0];
    }

    _changeDate(loadedDate) {
        return this.loadDate(loadedDate)
        .then((day) => {
            if (!day)
                return false;

            console.log('loaded', day);
            const { timestamps, urls } = day;
            const timestampsLength = timestamps.length;
            const urlsLength = urls.length;
            console.assert(timestampsLength === urlsLength, 
                'Array length mismatch');
            // Generate timeList
            const newTimeList = [];
            for (let i = 0; i < timestamps.length; ++i) {
                const date = new Date(timestamps[i]);
                const url = urls[i];
                const hh = String(date.getHours()).padStart(2, '0');
                const mm = String(date.getMinutes()).padStart(2, '0');
                const ss = String(date.getSeconds()).padStart(2, '0');
                const hhmmss = `${hh}${mm}${ss}`;
                newTimeList.push({
                    key: hhmmss,
                    value: url
                });
            }
            this.setState({
                timeList: newTimeList
            });
            return true;
        })
        .catch((err) => {
            console.log(err.stack);
            this.setState({
                timeList: null
            });
            if (err.message.toLowerCase().includes('not found'))
                return null;

            return false;
        });
    }

    setDateFailed(loadedDate) {
        return this.setDateSucceeded(loadedDate, false);
    }

    setDateSucceeded(loadedDate, succeeded = true) {
        if (!this._mounted)
            return;
        this.setState((prevState) => {
            const newFailed = new Set(prevState.failed);
            
            if (succeeded)
                newFailed.delete(loadedDate.getTime());
            else
                newFailed.add(loadedDate.getTime());

            return {
                failed: newFailed
            };
        });
    }

    loadDate(midnight, force = false) {
        // Local midnight
        const iter = new Date(midnight.getTime());
        // Local next midnight
        const nextMidnight = new Date(midnight.getTime());
        nextMidnight.setDate(nextMidnight.getDate() + 1);

        // Get raw timestamps for the local day span
        const stTs = iter.getTime();
        const enTs = nextMidnight.getTime();

        const utcMidnights = [];
        const promises = [];

        // Round down to start of intersecting UTC day
        iter.setUTCHours(0, 0, 0, 0);
        utcMidnights.push(new Date(iter.getTime()));

        // Get first day
        promises.push(this.getDayFromUTCMidnightAsync(
            new Date(iter.getTime()), force));

        // While we need more days, get the days
        for (;;) {
            // Advanced to next UTC midnight
            iter.setUTCDate(iter.getUTCDate() + 1);
            if (iter.getTime() >= enTs)
                break;
            utcMidnights.push(new Date(iter.getTime()));
            // Fetch that day
            promises.push(this.getDayFromUTCMidnightAsync(
                new Date(iter.getTime()), force));
        }

        return Promise.all(promises)
        .then((bodies) => {
            let utcDayIndex = -1;
            const timestamps = [];
            const urls = [];
            
            for (const body of bodies) {
                ++utcDayIndex;

                const bodyMidnight = utcMidnights[utcDayIndex];
                const bodyYear = bodyMidnight.getUTCFullYear();
                const bodyMonth = bodyMidnight.getUTCMonth();
                const bodyDay = bodyMidnight.getUTCDate();

                const timeKeys = Object.keys(body);
                const imageUrls = Object.values(body);

                let utcTimeIndex = -1;
                for (const time of timeKeys) {
                    ++utcTimeIndex;
                    const hh = +time.slice(0, 2);
                    const mm = +time.slice(2, 4);
                    const ss = +time.slice(4, 6);
                    const timestamp = Date.UTC(
                        bodyYear, bodyMonth, bodyDay,
                        hh, mm, ss);
                    if (timestamp >= stTs && timestamp < enTs) {
                        timestamps.push(timestamp);
                        urls.push(imageUrls[utcTimeIndex]);
                    }
                }
            }

            this.setDateSucceeded(midnight);

            console.assert(timestamps.length === urls.length);
            for (let i = 1; i < timestamps.length; ++i) {
                if (timestamps[i] <= timestamps[i-1])
                    throw new Error("Timestamps out of order!");
            }

            //
            return {
                timestamps,
                urls
            };
        }).catch((err) => {
            console.log(`Failed to load images` +
                    ` for ${midnight.toDateString()}:` +
                    (err.message));
            Toast.addToastToStateOf(this, {
                content: `Failed to load images` +
                    ` for ${midnight.toDateString()}`
            });
            this.setDateFailed(midnight);
            return null;
        });
    }

    _ws = null;

    // UTC keyed by timestamp (UTC midnights)
    // value is promise resoloving to a TimeMap 
    // (each property name is "hhmmss", their value is "url")
    _dayCache = new Map();
    _dayCacheLimit = 128;

    getDayFromUTCMidnightAsync(date, force = false) {
        if (date.getUTCHours() !== 0 ||
            date.getUTCMinutes() !== 0 ||
            date.getUTCSeconds() !== 0 ||
            date.getUTCMilliseconds() !== 0
        ) {
            throw new Error('Date must be aligned to UTC midnight');
        }

        const timestamp = date.getTime();

        // Fastpath
        let promise;
        if (!force) {
            promise = this._dayCache.get(timestamp);
            if (promise)
                return promise;
        }

        // Slow path (cache miss)
        const nextDay = new Date(timestamp);
        nextDay.setUTCDate(nextDay.getUTCDate() + 1);

        const yyyySt = date.getUTCFullYear();
        const yyyyEn = nextDay.getUTCFullYear();
        const mmSt = date.getUTCMonth() + 1;
        const mmEn = nextDay.getUTCMonth() + 1;
        const ddSt = date.getUTCDate();
        const ddEn = nextDay.getUTCDate();
        const pad = (n) => String(n).padStart(2, '0');
        const yyyymmddSt = `${yyyySt}${pad(mmSt)}${pad(ddSt)}`;
        const yyyymmddEn = `${yyyyEn}${pad(mmEn)}${pad(ddEn)}`;

        // Fetch one complete UTC day
        promise = this.fetchDayAsync(yyyymmddSt, yyyymmddEn);

        // Notice that we don't swallow the error,
        // this is a branch off the returned chain.
        // We evict erroneous cache entries, requesting
        // that day again will repeat the failed request
        promise.catch((err) => {
            console.log('day fetch error:', err);
            this._dayCache.delete(timestamp);
        });

        // Cap the cache size - drop the oldest entry
        if (this._dayCache.size >= this._dayCacheLimit) {
            const oldestKey = this._dayCache.keys().next().value;
            this._dayCache.delete(oldestKey);
        }

        this._dayCache.set(timestamp, promise);

        return promise;
    }

    fetchDayAsync(from, to) {
        return this.request(`/api/cam/${this.state.macaddr}/days` +
            `?from=${encodeURIComponent(from)}` +
            `&to=${encodeURIComponent(to)}`)
        .then((body) => {
            if (this.state.prefix !== body.prefix) {
                this.setState({
                    urlPrefix: body.prefix
                });
            }
            const days = body.days;
            const entries = Object.entries(days);
            if (entries.length === 1) {
                // It found one, return the timeMap at the 0th date
                return entries[0][1];
            } else if (entries.length === 0) {
                // It found none, return empty timeMap
                return {};
            } else {
                // This can't happen
                throw new Error(`Unexpected number of` +
                    ` day entries: ${entries.length}`);
            }
        });
    }

    request(url) {
        const token = localStorage.getItem('auth_token');

        return fetch(url, {
            headers: {
                authorization: token
            }
        })
        .then((response) => {
            if (!response.ok) {
                const statusCode = response.status;
                return Promise.reject(
                    new Error(`HTTP status ${statusCode}`));
            }

            const contentTypeHeader =
                response.headers.get('content-type') || '';

            const [
                contentType
            ] = contentTypeHeader.split(';', 1);

            if (contentType === 'application/json')
                return response.json();

            if (contentType === 'text/plain')
                return response.text();

            return response.blob();
        });
    }

    componentWillUnmount() {
        console.log('unmounted camera component');
        if (this._midnightTimer)
            clearTimeout(this._midnightTimer);
        this._midnightTimer = null;
        this._mounted = false;
    }

    _scheduleNextMidnight = () => {
        if (this._midnightTimer)
            clearTimeout(this._midnightTimer);

        const now = new Date();
        const nextMidnight = new Date(now);
        nextMidnight.setHours(24, 0, 0, 0);
        const ms = nextMidnight.getTime() - now.getTime();

        this._midnightTimer = setTimeout(() => {
            const d = new Date();
            d.setHours(0, 0, 0, 0);

            const minDate = new Date(d.getTime());
            // We only subtract 364 because today is
            // not properly after the last day
            // (it is the morning of the last day)
            minDate.setDate(minDate.getDate() - 364);

            this.setState({
                today: d,
                minDate: minDate
            }, () => {
                // reschedule again for the next day
                this._scheduleNextMidnight();
            });
        }, ms);
    };

    _setSelectedDate = (newDateOrNull) => {
        // if (newDateOrNull)
        //     newDateOrNull = new Date(+newDateOrNull);
        if (!newDateOrNull && !this.state.selectedDate)
            return;
        if (newDateOrNull && this.state.selectedDate &&
            +newDateOrNull === +this.state.selectedDate)
            return;
        console.log('selectedDate', newDateOrNull);
        // "Today" is null - it follows the today of "now"
        if (newDateOrNull &&
            newDateOrNull.getTime() >= this.state.today.getTime())
            newDateOrNull = null;
        this.setState({
            selectedDate: newDateOrNull
        });
    };

    _adjustSelectedDate = (adjMonth, adjDay, adjHour, adjPic) => {
        let newDate = new Date(this.state.selectedDate || this.state.today)
        if (adjMonth) {
            newDate.setMonth(newDate.getMonth() + adjMonth);
            if (newDate.getTime() > this.state.today.getTime())
                newDate.setTime(this.state.today.getTime());
            if (newDate.getTime() < this.state.minDate.getTime())
                newDate.setTime(this.state.minDate.getTime());
        }
        if (adjDay)
            newDate.setDate(newDate.getDate() + adjDay);
        if (newDate.getTime() >= this.state.today.getTime())
            newDate = null;
        this._setSelectedDate(newDate);

        if (adjPic) {
            const timeIndex = this._physicalTimeIndex();
            this.setTimeIndex(timeIndex + adjPic);
        }
    };

    _physicalTimeIndex() {
        return this.state.timeIndex === null
            ? (this.state.timeList &&
                this.state.timeList.length || 0) - 1
            : this.state.timeIndex;
    }

    _timeToDaySec(time) {
        const hht = time.slice(0, 2);
        const mmt = time.slice(2, 4);
        const sst = time.slice(4, 6);
        const hh = +hht;
        const mm = +mmt;
        const ss = +sst;
        const daySec = hh * 3600 + mm * 60 + ss;
        return daySec;
    }

    _findNearestTimeIndex(time) {
        const targetSec = this._timeToDaySec(time);
        let match = -1;
        let matchErr = 0;
        let i;
        const { timeList } = this.state;
        const end = (timeList || []).length;
        for (i = 0; i < end; ++i) {
            const timeEnt = timeList[i];
            const daySec = this._timeToDaySec(timeEnt.key);
            const err = daySec - targetSec;
            if (match < 0 || Math.abs(err) < Math.abs(matchErr)) {
                match = i;
                matchErr = err;
            }
            // Stop searching when it is only getting worse
            if (err > 0)
                break;
        }
        return match;
    }

    _zoomBy(factor) {
        const img = this._imageViewerRef.current;
        if (!img)
            return;

        // img -> .image-container -> .image-viewer (viewport)
        const viewport = img.parentElement && 
            img.parentElement.parentElement;
        if (!viewport)
            return;

        const rect = viewport.getBoundingClientRect();
        const cx = rect.width / 2;
        const cy = rect.height / 2;

        this.setState(function(prev) {
            const oldScale = prev.scale || 1;
            const newScale = oldScale * factor;
            const k = newScale / oldScale;

            return {
                scale: newScale,
                panX: (1 - k) * cx + k * prev.panX,
                panY: (1 - k) * cy + k * prev.panY
            };
        });
    }

    _timescrollerScrollRef = React.createRef();
    // The scroller links
    _timescrollerRefs = [];
    // Just the rows that have scroller link to it
    _timeEdgeRefs = [];
    // Every row
    _timeRefs = [];
    _imageViewerRef = React.createRef();

    _messageExpirer = null;

    render() {
        console.log('Rendering camera tab');

        if (this.state.cameraExists === null) {
            return <Fragment>Loading...</Fragment>;
        } else if (this.state.cameraExists === false) {
            return <Fragment>Camera not detected</Fragment>;
        }


        const timeListLen = this.state.timeList &&
            this.state.timeList.length || 0;

        // These are copied from the full edge ref array
        while (this._timeEdgeRefs.length < timescrollerTimes.length)
            this._timeEdgeRefs.push(null);

        while (this._timescrollerRefs.length < timescrollerTimes.length)
            this._timescrollerRefs.push(React.createRef());

        while (this._timeRefs.length < timeListLen)
            this._timeRefs.push(React.createRef());
        while (this._timeRefs.length > timeListLen)
            this._timeRefs.pop();

        const timeRows = this.state.timeList &&
            this.state.timeList.map(({key: time, value: url}, index) => {
            const timeKey = time.replace(/:/g, '').slice(0, 4);
            let refIndex = timescrollerTimeLookup.get(timeKey);
            if (refIndex === undefined)
                refIndex = -1;
            // console.log('time', time, 'resolved to',
            //     timeKey, 'and looked up', refIndex);

            // Copy the time ref to the time edge ref
            if (refIndex >= 0)
                this._timeEdgeRefs[refIndex] = this._timeRefs[index];

            const ref = this._timeRefs[index];
            const isSelected = this._physicalTimeIndex() === index;
            return <tr className="timepicker-row"
                key={time}
            >
                <td ref={ref}
                    className={"timepicker-time" +
                        (isSelected
                        ? ' selected' : '')
                    }
                    role="option"
                    tabIndex={isSelected ? 0 : -1}
                    aria-selected={isSelected}
                    onClick={(event) => {
                        const updatedIndex = (index < timeListLen - 1)
                            ? index
                            : null;
                        const target = event.target;
                        this.setState({
                            timeIndex: updatedIndex
                        }, () => {
                            this.centerTimeInView(updatedIndex, 
                                this._timeRefs);
                        });
                    }}
                    onKeyDown={(event) => {
                        let next = null;

                        if (event.key === 'ArrowDown') {
                            event.preventDefault();
                            if (this.state.timeList) {
                                next = Math.min(index + 1,
                                    this.state.timeList.length - 1);
                            }
                        } else if (event.key === 'ArrowUp') {
                            event.preventDefault();
                            next = Math.max(0, index - 1);
                        } else if (event.key === 'Home') {
                            event.preventDefault();
                            next = 0;
                        } else if (event.key === 'End') {
                            event.preventDefault();
                            if (this.state.timeList)
                                next = this.state.timeList.length - 1;
                        } else if (event.key === 'Enter' || 
                            event.key === ' '
                        ) {
                            event.preventDefault();
                            return;
                        } else {
                            console.log('ignoring keypress:', event.key);
                            return;
                        }

                        const el = this._timeRefs[next] &&
                            this._timeRefs[next].current;
                        if (el) {
                            this.setTimeIndex(next);
                        }
                    }}
                >
                    <span className="noto">
                        📸
                    </span>
                    &nbsp;{time}
                </td>
            </tr>;
        });

        // console.log('timescroller refs', this._timescrollerRefs);

        // This element scrolls its children
        const timepickerContainer =
        <div className="timepicker-container inline-container"
            ref={this._timescrollerScrollRef}
        >
            <table className="timepicker-table">
                <tbody children={timeRows}/>
            </table>
        </div>;

        const { timescrollerHighlightIndex } = this.state;

        const timescrollerButtons = timescrollerTimes.map((info, index) => {
            const assocTimeIndex = 
                timescrollerTimeLookup.get(info.key);
            const disabled = !this._timeEdgeRefs[assocTimeIndex] ||
                !this._timeEdgeRefs[assocTimeIndex].current;
            return !disabled && <a
                ref={this._timescrollerRefs[index]}
                href='#'
                key={info.key}
                disabled={disabled}
                onClick={(event) => {
                    event.preventDefault();
                    if (assocTimeIndex !== undefined)
                        this.setTimeIndex(assocTimeIndex, this._timeEdgeRefs);
                }}
                className={timescrollerHighlightIndex === index
                    ? ' selected' : ''}
            >
                {info.value} ({insertColons(info.key)})
            </a>
        }).filter((jsx) => jsx);

        const timescrollerContainer =
        <div className="timescroller-container inline-container">
            {timescrollerButtons}
        </div>;

        const physicalIndex = this._physicalTimeIndex();

        const currentImage = this.state.timeList &&
            this.state.timeList[physicalIndex] &&
            this.state.timeList[physicalIndex].value &&
            (this.state.urlPrefix + 
            this.state.timeList[physicalIndex].value) ||
            null;
        
        const firstPic = physicalIndex === 0;
        const lastPic = this.state.timeList ?
             physicalIndex + 1 === timeListLen
             : true;

        return <Fragment>
            <Toast messages={this.state.messages}
                onExpire={this._messageExpirer}/>
            <div className="datetimepicker-container">
                <Calendar
                    today={this.state.today}
                    selectedDate={this.state.selectedDate}
                    minDate={this.state.minDate}
                    failed={this.state.failed}
                    onChangeSelectedDate={(date) => {
                        this._setSelectedDate(date);
                    }}
                 />
                {timepickerContainer}
                {timescrollerContainer}
            </div>
            <div className="image-controls">
                <button 
                    type="button"
                    onClick={(event) => {
                        event.preventDefault();
                        this._imageViewerRef.current.requestFullscreen();
                    }}
                >
                    Fullscreen
                </button>
                <button 
                    type="button"
                    onClick={(event) => {
                        event.preventDefault();
                        const a = document.createElement('a');
                        a.href = currentImage +
                            (currentImage.includes('?') ? '&' : '?') +
                            'download=1';
                        a.download = '';
                        a.target = 'imageDownload';
                        a.click();
                    }}
                >
                    Download
                </button>
                <button
                    type="button"
                    disabled={firstPic}
                    onClick={(event) => {
                        event.preventDefault();
                        this._adjustSelectedDate(0, 0, 0, -1);
                    }}
                >
                    ◀ Pic
                </button>
                <button
                    type="button"
                    disabled={lastPic}
                    onClick={(event) => {
                        event.preventDefault();
                        this._adjustSelectedDate(0, 0, 0, 1);
                    }}
                >
                    ▶ Pic
                </button>
                
                <label className="range-parent">
                    <span className="noto">☀</span>&nbsp;
                    Brightness
                    <input type="range" min="0" max="30" step="0.01"
                        onChange={(event) => {
                            this.setState({
                                brightness: +event.target.value
                            });
                        }}
                        value={this.state.brightness}
                        />
                    {this.state.brightness.toFixed(1)}x
                    <button 
                        type="button"
                        onClick={(event) => {
                            event.preventDefault();
                            this.setState({
                                brightness: 1.0
                            });
                        }}
                    >
                        1️⃣
                </button>
                </label>
                <label className="range-parent">
                    <span className="noto">◐</span>&nbsp;
                    Contrast
                    <input type="range" min="0" max="10" step="0.01"
                        onChange={(event) => {
                            event.preventDefault();
                            this.setState({
                                contrast: +event.target.value
                            });
                        }}
                        value={this.state.contrast}
                        />
                    {this.state.contrast.toFixed(1)}x
                    <button 
                        type="button"
                        onClick={(event) => {
                            event.preventDefault();
                            this.setState({
                                contrast: 1.0
                            });
                        }}
                    >
                        1️⃣
                    </button>
                </label>
                <button
                    type="button"
                    onClick={(event) => {
                        event.preventDefault();
                        this._zoomBy(1.5);
                        // this.setState((prevState) => {
                        //     return {
                        //         scale: prevState.scale * 1.5
                        //     };
                        // });
                    }}
                >
                    Zoom In
                </button>
                <button
                    type="button"
                    onClick={(event) => {
                        event.preventDefault();
                        this._zoomBy(2 / 3)
                        // this.setState((prevState) => {
                        //     return {
                        //         scale: prevState.scale * 2/3
                        //     };
                        // });
                    }}
                >
                    Zoom Out
                </button>
                <button
                    type="button"
                    onClick={(event) => {
                        event.preventDefault();
                        this.setState((prevState) => {
                            return {
                                scale: 1,
                                panX: 0,
                                panY: 0
                            };
                        });
                    }}
                >
                    Fit
                </button>
            </div>
            <div className="image-viewer"
                tabIndex={0}
                role="application"
                alt="Image"
            >
                <div className="image-container">
                    {currentImage && <img
                        ref={this._imageViewerRef}
                        className={"image-viewer"}
                        style={{
                            transform: `translate(${this.state.panX}px,` +
                                ` ${this.state.panY}px)` +
                                ` scale(${this.state.scale})`,
                            filter: `brightness(${this.state.brightness})` +
                                ` contrast(${this.state.contrast})`,
                            cursor: this._captured ? 'grabbing' : 'default'
                        }}
                        onContextMenu={(event) => {
                            event.preventDefault();
                        }}
                        onPointerDown={(event) => {
                            event.preventDefault();
                            this._dragStX = event.clientX;
                            this._dragStY = event.clientY;
                            this._panStX = this.state.panX;
                            this._panStY = this.state.panY;
                            this._captured = this._imageViewerRef.current;
                            this._capturePointerId = event.pointerId;
                            this._captured.setPointerCapture(
                                this._capturePointerId);
                        }}
                        onPointerUp={(event) => {
                            event.preventDefault();
                            if (this._captured) {
                                this._captured.releasePointerCapture(
                                    this._capturePointerId);
                                this._captured = null;
                                this._capturePointerId = null;
                            }
                        }}
                        onPointerMove={(event) => {
                            event.preventDefault();
                            if (this._captured) {
                                const newX = (event.clientX - this._dragStX) +
                                    this._panStX;
                                const newY = (event.clientY - this._dragStY) +
                                    this._panStY;
                                if (this.state.panX !== newX || 
                                    this.state.panY !== newY
                                ) {
                                    this.setState({
                                        panX: newX,
                                        panY: newY
                                    });
                                }
                            }
                        }}
                        src={currentImage}
                        /> || 'No image selected'}
                </div>
            </div>
        </Fragment>;
    }

    centerTimeInView(index, refSource = this._timeRefs) {
        const parent = this._timescrollerScrollRef.current;
        const refSourceRef = refSource && refSource[index];
        if (!refSourceRef)
            return false;
        const child = refSourceRef.current;
        const parentRect = parent.getBoundingClientRect();
        const childRect = child.getBoundingClientRect();
        const parentMid = parentRect.top + (parentRect.height / 2);
        const childMid = childRect.top + (childRect.height / 2);
        // If child is off the bottom of the viewport,
        // then childMid > parentMid,
        // and scrollTop needs to be increased
        // (which moves the child up into view)
        const adj = childMid - parentMid;
        //parent.scrollTop += adj;
        return child;
    }

    setTimeIndex(index, refSource = this._timeRefs) {
        const child = this.centerTimeInView(index, refSource);
        child.click();
        child.focus();
        return true;
    }
}

function insertColons(timekey, withSeconds = false) {
    if (!timekey)
        return timekey;
    const hh = timekey.slice(0, 2);
    const mm = timekey.slice(2, 4);
    const ss = timekey.slice(4, 6);
    return `${hh}:${mm}${withSeconds?`:${ss}`:''}`;
}


